export type tData = {
  slug: string;
  name: string;
};

export interface iLetter {
  initial: string;
  data: tData[];
}

export interface iAlphabetAccumulator {
  [key: string]: iLetter;
}

export enum eBaseUrl {
  GALLERIES = 'galleries',
  ARTISTS = 'artists',
}
